import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Loader from "../../components/Loader";
import { addAgent, changeReferralCode } from "../../utils/apis/func";
import { useQuery } from "@chakra-ui/react";
import { useAppSelector } from "../../utils/redux/hooks";
import { RootState } from "../../utils/redux/store";

const CustomizeAgent = () => {
  const navigate = useNavigate();
  const query = useParams();
  const [isLoading, setisLoading] = useState(false);
  const initialValues = {
    user: query?.id || "",
    code: "",
  };
  const validationSchema = Yup.object().shape({
    user: Yup.string().required("user is required"),
    code: Yup.string().required("code is required"),
  });

  const viewCustomer: any = useAppSelector(
    (store: RootState) => store.user.viewCustomer
  );

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    console.log("====================================");
    console.log("started");
    console.log("====================================");

    if (query?.id !== viewCustomer?._id) {
      toast("ID Mismatched!.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
    try {
      setisLoading(true);
      const res = await changeReferralCode({
        userID: values.user,
        referralCode: values.code,
      });
      if (res?.status === 200 || res?.status === 201) {
        toast("Referral Code changed Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error Referral Code:", error);
    } finally {
      setisLoading(false);
    }
    setSubmitting(false);
  };

  const [showPassword, setShowPassword] = useState(false);

  console.log(viewCustomer);

  return (
    <>
      <div className="px-3">
        <p className="text-[#000] font-roboto text-2xl font-medium leading-normal mt-4 border-b-2 border-[#000] w-fit px-4 pr-8">
          Customize Referral Code
        </p>
      </div>
      <main>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="flex flex-col overflow-auto h-[100vh] gap-7 w-full lg:w-2/5 font-roboto text-sm font-normal leading-normal px-2 lg:px-6 mt-8">
              <div className="bg-[#8E8E93]  h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  User:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type="text"
                    id="user"
                    name="user"
                    disabled
                  />
                </p>
                <ErrorMessage
                  name="user"
                  component="div"
                  className="text-red-500"
                />
              </div>

              <div className="bg-[#8E8E93]  h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  Name:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow  rounded-lg px-1 items-center justify-between"
                    type="text"
                    id="name"
                    name="name"
                    disabled
                    value={`${
                      viewCustomer?.businessName ??
                      `${viewCustomer?.firstName} ${viewCustomer?.lastName}`
                    }`}
                  />
                </p>
              </div>
              <div className="bg-[#8E8E93]  h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  Email:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow  rounded-lg px-1 items-center justify-between"
                    type="text"
                    id="name"
                    name="name"
                    disabled
                    value={`${viewCustomer?.email}`}
                  />
                </p>
              </div>

              <div className="bg-[#8E8E93]  h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                 Current Referral Code:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type="text"
                    id="exCode"
                    name="exCode"
                    disabled
                    value={`${viewCustomer?.referralCode}`}
                  />
                </p>
              </div>

              <div className="bg-[#8E8E93] h-[5vh] border border-[#88087B] rounded-sm">
                <p className="flex items-center">
                  New Code:{" "}
                  <Field
                    className="ml-4 flex   h-[4.7vh] flex-grow bg-[#fff] rounded-lg px-1 items-center justify-between"
                    type="text"
                    id="code"
                    name="code"
                  />
                </p>
                <ErrorMessage
                  name="code"
                  component="div"
                  className="text-red-500"
                />
              </div>

              <div className="flex items-center justify-center">
                {isSubmitting || isLoading ? (
                  <div className="text-center">
                    <div role="status">
                      <svg
                        aria-hidden="true"
                        className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="bg-[#88087B] sm:w-[100%] sm:h-[5vh] lg:w-[25vw]  px-5 text-[#FFCD1E] rounded-md  text-shadow-md font-roboto text-lg font-medium leading-normal"
                  >
                    Proceed
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      </main>
      {isLoading && <Loader />}
    </>
  );
};

export default CustomizeAgent;
